// src/constants.ts
var SITE_NAME = "Junat.live";
var SITE_DOMAIN = "junat.live";
var SITE_URL = "https://junat.live";
var DEFAULT_LOCALE = "fi";
var LOCALES = ["fi", "en"];
var INACTIVE_STATIONS = [
  "HSI",
  "HH",
  "KIA",
  "K\xD6",
  "LVT",
  "NL\xC4",
  "PRV",
  "MVA",
  "PTL",
  "PTR",
  "LAI"
  // TODO: has summer traffic / seasonal use, but is inactive
  // 'HLS',
];
var DEFAULT_TRAINS_COUNT = 20;
var TRAINS_MULTIPLIER = 100;
var TRAINS_OVERSHOOT = 5;
var FINTRAFFIC = {
  URL: "https://www.fintraffic.fi/",
  LICENSE_URL: "https://creativecommons.org/licenses/by/4.0/deed.",
  LICENSE: "CC 4.0 BY",
  LOCALE_PATHS: { fi: "fi", en: "en" }
};
var constants_default = {};
export {
  DEFAULT_LOCALE,
  DEFAULT_TRAINS_COUNT,
  FINTRAFFIC,
  INACTIVE_STATIONS,
  LOCALES,
  SITE_DOMAIN,
  SITE_NAME,
  SITE_URL,
  TRAINS_MULTIPLIER,
  TRAINS_OVERSHOOT,
  constants_default as default
};
//# sourceMappingURL=constants.js.map